import React from 'react';
import { View } from 'react-native';
import useTranslation from '../../hooks/translation-hook';
import useCustomTheme from '../../hooks/theme-hook';
import Label from '../common/Label';
import Loading from '../common/Loading';
import CustomButton from '../common/CustomButton';

export default function CampaignSecurityLoading({ failed, retry }: { failed: boolean; retry: () => void }) {
  const text = useTranslation();
  const theme = useCustomTheme();
  return <View style={{ flex: 1, padding: 24, justifyContent: 'center', alignItems: 'center', backgroundColor: theme.background.primary as any }}>
    {failed ? <>
      <View accessibilityRole="alert" style={{ width: '100%', maxWidth: 420, gap: 20 }}>
        <Label numberOfLines={0} style={{ textAlign: 'center' }}>{text('Something-went-wrong-please-try-again-later')}</Label>
        <CustomButton title={text('retry')} onPress={retry} textStyle={{ color: '#ffffff' }} />
      </View>
    </> : <Loading />}
  </View>;
}
